import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  props: {
    src: String
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "glass-view",
        style: _normalizeStyle({
          '--backgroundImg': `url(${__props.src})`
        })
      }, null, 4);
    };
  }

};